import * as React from 'react';
// import { styled } from '@mui/material/styles';
import { Box, Paper,Typography } from '@mui/material';

import Grid from '@mui/material/Unstable_Grid2';

// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';


import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { widgetsApi } from '../../service/Widgets.service';


const ServiceExcellence = () => {
    const [data, setData] = React.useState([]);
    const [loader, setLoader] = React.useState(true);

    const ServiceExcellence = {
        autoplay: true,
        // rtl: true,
        autoplayHoverPause: true,
        autoplayTimeout: 5000,
        smartSpeed: 2000,
        animateOut: 'fadeOut',
        // loop: true,
        margin: 20,
        nav: true,
        dots: false,
        navElement: 'div',
        // navText: ["<i class='fas fa-arrow-alt-circle-left'></i>", "<i class='fas fa-arrow-alt-circle-right'></i>"],
        responsive: {
            0: {
                items: 2
            },
            600: {
                items: 3
            },
            1000: {
                items: 5
            }
        }
    }
    React.useEffect(() => {
        getServiceExcellence();
        setLoader(true);
    },[]);

    const getServiceExcellence = async () => {
        const res = await widgetsApi.serviceExcellence();
        if (res.status === 200 && res.data.status === 200 && res.data.success === true) {
            await setData(res.data.data);
            setLoader(false);
        }
    }

    return (
        <>
        {loader ? '' : <Box sx={{ flexGrow: 1 }} className='serviceExcellence relative' pt='0'>
                <Box sx={{ flexGrow: 1 }} className='ph-80'>
                    <Grid container spacing={3} padding={3} alignItems={'center'}>
                        <Grid item xs={12} py='0'>
                            <Paper sx={{ backgroundColor: "transparent", boxShadow: "none", textAlign: "center" }} className='sectionTitle'>
                                <Typography variant="h6_df">
                                   Lorem Ipsum
                                </Typography>
                                <Typography variant="h2"  display="block">
                                   Service Excellence
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} className="aboutSlider">
                            <OwlCarousel className='owl-theme' {...ServiceExcellence}>
                                {data.map((element, index) => (
                                    <div class='item'>
                                        <Paper component="a" href="/" className="popularToursSlider tourImgMd"
                                            sx={{
                                                boxShadow: "none",
                                                backgroundColor: 'transparent',
                                                border: '#d7d7d7 1px solid',
                                                borderRadius:'10px',
                                                overflow:'hidden',
                                            }} 
                                        >
                                            <img src={`${process.env.REACT_APP_HOST_IMAGE}image/serviceExcellence/${element.image}`} alt="" />

                                        </Paper>
                                    </div>
                                ))}
                            </OwlCarousel>
                        </Grid>
                    </Grid>
                </Box>
            </Box>}
            
        </>
    )
}

export default ServiceExcellence
